module.exports = __webpack_public_path__ + "media/widget/logo_black-ee340eaa.png";